<template>
  <div
    class="toast-container position-fixed top-0 end-0 p-3"
    style="z-index: 2000"
  >
    <div
      v-for="(msg, index) in messages"
      :key="index"
      class="toast align-items-center show mb-2"
      :class="
        msg.type === 'success'
          ? 'bg-success text-white'
          : 'bg-danger text-white'
      "
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body">{{ msg.text }}</div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          @click="remove(index)"
        ></button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const messages = ref([]);

function showToast(text, type = "success") {
  messages.value.push({ text, type });
  setTimeout(() => {
    messages.value.shift();
  }, 4000);
}

function remove(index) {
  messages.value.splice(index, 1);
}

// exportujeme funkci pro volání zvenčí
defineExpose({ showToast });
</script>
